import { LogSearch, LogAddress } from "../interfaces/log";
import { Ihalfway } from "../reducers/halfway";

// Open street maps geocoder Url
// See: https://wiki.openstreetmap.org/wiki/Key:place
function getOsmGeocoderUrl(latlng: google.maps.LatLngLiteral): string {
    return "https://nominatim.openstreetmap.org/reverse?format=json&lat=" +
        encodeURIComponent(latlng.lat)
        + "&lon=" +
        encodeURIComponent(latlng.lng)
        + "&zoom=18&addressdetails=1";
}

async function fetchGeocode(latlng: google.maps.LatLngLiteral) {
    const url = getOsmGeocoderUrl(latlng);
    const data = await fetch(url);
    // convert data to json
    const json = await data.json();
    return json;
}

async function postSearch(search: LogSearch, token: string) {
    const url = "/api/Log/LogSearch?token=" +
        encodeURIComponent(token);

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(search)
    });
}

function getAddressFromGeocode(json): LogAddress {
    if (!json) {
        return null;
    }
    if (!json.state || !json.country) {
        return null;
    }
    const city = json.city ? json.city : (json.town ? json.town : (json.village ? json.village : null));
    if (!city) {
        return null;
    }
    return {
        city: city,
        state: json.state,
        country: json.country
    };
}

export async function logSearch(halfway: Ihalfway, token: string) {
    const json1 = await fetchGeocode(halfway.startLatLng);
    const json2 = await fetchGeocode(halfway.endLatLng);
    const adr1 = getAddressFromGeocode(json1.address);
    const adr2 = getAddressFromGeocode(json2.address);
    //console.log(json1.address);
    //console.log(json2.address);
    adr1.lat = halfway.startLatLng.lat;
    adr1.lng = halfway.startLatLng.lng;
    adr2.lat = halfway.endLatLng.lat;
    adr2.lng = halfway.endLatLng.lng;
    //console.log(adr1);
    //console.log(adr2);
    if (adr1 && adr2) {
        const logsearch: LogSearch = {
            address1: adr1,
            address2: adr2,
            halfway: {
                lat: halfway.latLng.lat,
                lng: halfway.latLng.lng,
                locationName: halfway.locationName,
                locationNameLong: halfway.locationNameLong,
                totalDistance: halfway.totalDistance,
                term: halfway.term,
            }
        };
        await postSearch(logsearch, token);
    }
}
